import { NEXXUS_LICENCE_PUBLIC_KEY } from './PublicKey';
import { isRecetteBuild, recetteLicencePublicKey } from '@shared/constants/buildProfile';

/** Registre des clés publiques par `kid` (rotation supportée côté client). */
export const LICENCE_PUBLIC_KEYS: Record<string, string> = {
  'nexxus-1': NEXXUS_LICENCE_PUBLIC_KEY,
};

export function resolvePublicKey(kid: string | undefined): string | null {
  // Build de recette : UNIQUEMENT la clé publique de recette (jamais celle de production).
  if (isRecetteBuild()) {
    const recette = recetteLicencePublicKey();
    if (!recette) return null;
    return !kid || kid === recette.kid ? recette.pem : null;
  }
  if (!kid) return LICENCE_PUBLIC_KEYS['nexxus-1'] ?? null;
  return LICENCE_PUBLIC_KEYS[kid] ?? null;
}
